var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1797 4.08984L19.0898 0H15.6797L19.7695 4.08984H23.1797ZM1.36523 0H0V4.08984H5.45508L1.36523 0ZM14.3203 4.08984L10.2246 0H6.81445L10.9043 4.08984H14.3203ZM24.5449 9.54492H19.0898L23.1797 5.45508H19.7695L15.6797 9.54492H10.2246L14.3145 5.45508H10.9043L6.81445 9.54492H1.36523L5.45508 5.45508H0V27.2754C0 28.7754 1.22461 30 2.72461 30H27.2695C28.7754 30 29.9941 28.7754 29.9941 27.2754V5.45508H28.6289L24.5449 9.54492ZM10.9102 25.9102V13.6348L21.8203 19.7695L10.9102 25.9102ZM24.5449 0L28.6348 4.08984H30V0H24.5449Z",
    fill: "#699BF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.a0a498e3d9e01352098cefba9073b576.svg";
export { ForwardRef as ReactComponent };